import {ApDynformsConfigFieldset}                          from '../../../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {
  ApDynformsConfigNumerictextbox
}                                                          from '../../../../ap-dynforms/config/ap-dynforms-config-numerictextbox';
import {
  ApDynformsConfigTextarea
}                                                          from '../../../../ap-dynforms/config/ap-dynforms-config-textarea';
import {
  ApDynformsConfigDatepicker
}                                                          from '../../../../ap-dynforms/config/ap-dynforms-config-datepicker';
import {
  ApDynformsConfigComboBox
}                                                          from '../../../../ap-dynforms/config/ap-dynforms-config-combobox';
import {DriverStore}                                       from '../../../../stores/docu/driver.store';
import {InstrumentStore}                                   from '../../../../stores/docu/instrument.store';
import {MachineStore}                                      from '../../../../stores/docu/machine.store';
import {EventEmitter, Injectable, TemplateRef}             from '@angular/core';
import {nameOf}                                            from '../../../../ap-core/utils/ap-name-of';
import {ILogFileEditWizard, IPpLogEditProductListGridItem} from '../pp-logfile-edit-wizard.types';
import {combineLatest, merge, Observable, of}              from 'rxjs';
import {delay, distinctUntilChanged, map, skip}            from 'rxjs/operators';
import {
  ApDynformsConfigPlaceholder
}                                                          from '../../../../ap-dynforms/config/ap-dynforms-config-placeholder';
import {
  ApDynformsConfigButton
}                                                          from '../../../../ap-dynforms/config/ap-dynforms-config-button';
import {
  ApDynGridPropertyColumnConfig
}                                                          from '../../../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {
  ApDynGridButtonColumnConfig
}                                                          from '../../../../ap-dyngrids/config/ap-dyn-grid-button-column-config';
import {
  ApDynGridColumnConfigBase
}                                                          from '../../../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {GetRoundNumericPipe}                               from '../../../../ap-utils';
import {
  ApDynformsConfigTemplate
}                                                          from '../../../../ap-dynforms/config/ap-dynforms-config-template';
import {
  PlantProtectionProductStore
}                                                          from '../../../../stores/base-data/plantprotection.product.store';
import {IDisplayName}                                      from '../../../../types/common-types';
import {
  PlantProtectionPlanBookStore
}                                                          from '../../../../stores/plant-protection/plant-protection-planbook.store';
import {CropTypeStore}                                     from '../../../../stores/base-data/crop.types.store';
import {ApTranslationPipe}                                 from '../../../../translation/pipes/ap-translation.pipe';
import {UnitService}                                       from '../../../../services/data/unit.service';
import IInstrument = Data.DocuContext.Instrument.IInstrument;
import IDatasetFieldMap = Data.Sensor.IDatasetFieldMap;
import IPlantProtectionSensorLogHeaderData = Data.Import.IPlantProtectionSensorLogHeaderData;
import IPlantProtectionPlanBook = Data.TaskManagement.IPlantProtectionPlanBook;
import IDriver = Data.DocuContext.Driver.IDriver;
import IMachine = Data.DocuContext.Machine.IMachine;
import IPlantProtectionProduct = Data.BaseData.IPlantProtectionProduct;
import IPlantProtectionProductDetails = Data.BaseData.IPlantProtectionProductDetails;

@Injectable({providedIn: 'root'})
export class PpLogfileEditWizardUiProvider {
  public addProduct = new EventEmitter<void>();
  public deleteProduct = new EventEmitter<IPpLogEditProductListGridItem>();

  constructor(
    private cropTypeStore: CropTypeStore,
    private driverStore: DriverStore,
    private instrumentStore: InstrumentStore,
    private machineStore: MachineStore,
    private planBookStore: PlantProtectionPlanBookStore,
    private productStore: PlantProtectionProductStore,
    private roundNumericPipe: GetRoundNumericPipe,
    private unitService: UnitService,
    private translationPipe: ApTranslationPipe) {
  }

  public getProductList(): ApDynGridColumnConfigBase[] {
    return [
      new ApDynGridPropertyColumnConfig({
        field: `${nameOf<IPpLogEditProductListGridItem>('ProductItem')}.${String(nameOf<IPlantProtectionProduct>('ProductName'))}`,
      }),
      new ApDynGridPropertyColumnConfig({
        field: nameOf<IPpLogEditProductListGridItem>('ApplRate'),
        width: 60,
        cssClass: 'right',
        pipes: [{
          pipe: this.roundNumericPipe,
          args: []
        }]
      }),
      new ApDynGridPropertyColumnConfig({
        field: nameOf<IPpLogEditProductListGridItem>('Unit'),
        pipes: [{
          pipe: this.translationPipe,
          args: []
        }],
        width: 60
      }),
      new ApDynGridButtonColumnConfig(
        {
          tooltip: 'Global__Delete',
          callback: this.deleteProduct,
          isStandardIcon: true,
          standardIcon: nameOf<IPpLogEditProductListGridItem>('ButtonIconName')
        }
      )];
  }

  public getLogfileFieldset(data: IDatasetFieldMap): ApDynformsConfigFieldset {
    return new ApDynformsConfigFieldset({
      key: 'Logfile',
      legend: 'N__Logfile',
      config: [
        new ApDynformsConfigNumerictextbox({
          key: nameOf<ILogFileEditWizard>('Ec'),
          label: 'Global__ECStageShort',
          value: data.Ec,
          disabled: true
        }),
        new ApDynformsConfigNumerictextbox({
          key: nameOf<ILogFileEditWizard>('WorkingWidth'),
          label: 'Docu_Ini__WorkingWidth_m',
          value: data.WorkingWidth,
          min: 0
        }),
        new ApDynformsConfigDatepicker({
          key: nameOf<ILogFileEditWizard>('Date'),
          label: 'Nutrients__FertilizationDate',
          value: new Date(data.DataSet?.Created),
          disabled: true
        })
      ]
    });
  }

  public getProductsFieldset(data: IDatasetFieldMap,
                             values$: Observable<ILogFileEditWizard>,
                             plannings: Observable<IDisplayName[]>,
                             selectedPlannings$: Observable<IPpLogEditProductListGridItem[]>,
                             templateRef: TemplateRef<any>): ApDynformsConfigFieldset {
    const product$ = values$.pipe(
      delay(1),
      map((v): IPlantProtectionProduct => this.productStore.Listen(s => s.data).value.find((p) => p.Id === v.Product)),
      distinctUntilChanged((previous, current) => previous?.Id === current?.Id),
    );

    return new ApDynformsConfigFieldset({
      key: 'Products',
      legend: 'Global__Products',
      config: [
        new ApDynformsConfigPlaceholder({}),
        new ApDynformsConfigComboBox({
          key: nameOf<ILogFileEditWizard>('Plan'),
          label: 'Global__Plannings',
          options: plannings,
          valueField: 'Id',
          textField: 'DisplayName',
          value: data.PlantProtectionPlanBook?.Id ?? null
        }),
        new ApDynformsConfigTextarea({
          key: nameOf<ILogFileEditWizard>('LogfileProducts'),
          label: 'Global__Logfiles',
          value: this._getLogfileProducts(data).join('\n'),
          disabled: true,
          rows: 4
        }),
        new ApDynformsConfigTemplate({
          key: nameOf<ILogFileEditWizard>('PlanningProducts'),
          value: templateRef
        }),
        new ApDynformsConfigPlaceholder({}),
        new ApDynformsConfigComboBox({
          key: nameOf<ILogFileEditWizard>('Product'),
          label: 'Global__Product',
          options: combineLatest([
            this.productStore.Listen((s) => s.data),
            selectedPlannings$
          ]).pipe(
            map(([products, values]) =>
              products.filter((product) => product.Selectable &&
                product.ProductDetails.find((details) =>
                  details.EcMin <= data.Ec && details.EcMax >= data.Ec &&
                  details.EppoCrop === this.cropTypeStore.GetEppoCode(data.CropType)) != null &&
                values.find((value) => value.ProductItem?.Id === product.Id) == null
              )
            )
          ),
          valueField: nameOf<IPlantProtectionProduct>('Id') as string,
          textField: nameOf<IPlantProtectionProduct>('ProductName') as string
        }),
        new ApDynformsConfigPlaceholder({}),
        new ApDynformsConfigNumerictextbox({
          key: nameOf<ILogFileEditWizard>('Maximum'),
          label: this._setDefaultLable('Global__Maximum'),
          label$: product$.pipe(
            map((product) => this._setLableByProduct('Global__Maximum', data, product))
          ),
          disabled: true,
          value$: product$.pipe(
            map((product) => {
              if (product == null) {
                return undefined;
              }
              return product?.ProductDetails?.find((d) =>
                d.EcMin <= data.Ec && d.EcMax >= data.Ec && this.cropTypeStore.getDefaultCroptype(data.CropType).Eppocode === d.EppoCrop)?.AmountMax;
            }))
        }),
        new ApDynformsConfigPlaceholder({}),
        new ApDynformsConfigNumerictextbox({
          key: nameOf<ILogFileEditWizard>('AvgProduct'),
          label: this._setDefaultLable('Global__Product_avg'),
          label$: product$.pipe(
            map((product) => this._setLableByProduct('Global__Product_avg', data, product))
          ),
          step: product$.pipe(
            map((product) => {
              return product ? (this._getProduct(data, product)?.AmountMax >= 100 ? 10 : 1) : 1;
            })),
          min: 0,
          max: product$.pipe(
            delay(10),
            map((product) => {
              return product ? this._getProduct(data, product)?.AmountMax : undefined;
            })),
          value$: merge(
            product$.pipe(map(() => undefined)),
            values$.pipe(map((value) => value.AvgProduct))
          )
        }),
        new ApDynformsConfigPlaceholder({}),
        new ApDynformsConfigButton({
          key: 'productButton',
          value: 'Transfer',
          callback: this.addProduct,
          disabledButton$: merge(values$.pipe(
            map((values) => values.Product == null || values.AvgProduct == null)
          ), of(true))
        })
      ]
    });
  }

  public getDocuFieldset(data: IDatasetFieldMap, values$: Observable<ILogFileEditWizard>): ApDynformsConfigFieldset {
    const plan$ = values$.pipe(
      map((v): IPlantProtectionPlanBook => this.planBookStore.Listen(s => s.data).value.find((p) => p.Id === v.Plan)),
      distinctUntilChanged((previous, current) => previous?.Id === current?.Id),
    );

    return new ApDynformsConfigFieldset({
      key: 'Docu',
      legend: 'Settings__Lbl_Menu_Resources',
      config: [
        new ApDynformsConfigComboBox({
          key: 'Driver',
          label: 'Global__Worker',
          options: this.driverStore.Listen(s => s.data),
          textField: nameOf<IDriver>('FullName') as string,
          valueField: nameOf<IDriver>('Id') as string,
          valuePrimitive: true,
          value: data.PlantProtectionPlanBook?.ExportDriver,
          value$: plan$.pipe(
            skip(1),
            map((p) => p?.ExportDriver)
          )
        }),
        new ApDynformsConfigComboBox({
          key: 'Machine',
          label: 'Docu_Ini__Engine',
          options: this.machineStore.Listen(s => s.data),
          textField: nameOf<IMachine>('NameWithSign') as string,
          valueField: nameOf<IMachine>('Id') as string,
          valuePrimitive: true,
          value: data.PlantProtectionPlanBook?.ExportMachine,
          value$: plan$.pipe(
            skip(1),
            map((p) => p?.ExportMachine)
          )
        }),
        new ApDynformsConfigComboBox({
          key: 'Instrument',
          label: 'AgriConnect_Ini__Tool',
          options: this.instrumentStore.Listen(s => s.data),
          textField: nameOf<IInstrument>('Name') as string,
          valueField: nameOf<IInstrument>('Id') as string,
          valuePrimitive: true,
          value: data.PlantProtectionPlanBook?.ExportInstrument,
          value$: plan$.pipe(
            skip(1),
            map((p) => p?.ExportInstrument)
          )
        }),
      ]
    });
  }

  private _getLogfileProducts(data: IDatasetFieldMap): string[] {
    const json: IPlantProtectionSensorLogHeaderData = JSON.parse(data.DataSet.HeaderValuesString);
    if (json?.Agents) {
      return json.Agents.map((agent) => agent?.Name + ' ' + agent?.AStd + ' ' + agent?.Unit);
    }
    return [];
  }

  private _getProduct(data: IDatasetFieldMap, product: IPlantProtectionProduct | null): IPlantProtectionProductDetails {
    return product?.ProductDetails?.find(d =>
      d.EcMin <= data.Ec && d.EcMax >= data.Ec && this.cropTypeStore.getDefaultCroptype(data.CropType).Eppocode === d.EppoCrop);
  }

  private _setLableByProduct(key: string, data: IDatasetFieldMap, product: IPlantProtectionProduct | null): string {
    const productDetails = this._getProduct(data, product);
    if (!productDetails) {
      return this._setDefaultLable(key);
    }
    return this.unitService.getUnitWithLabelKey(productDetails.Unit, key);
  }

  private _setDefaultLable(key: string): string {
    return this.unitService.getUnitWithLabelKey(null, key);
  }
}
